

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppHeading } from '../../typography';
import { ListPageLayout } from '../../layouts';
import { Components } from './types';
import { ASYNC_COMPONENTS } from './consts';

@Component({
  components: {
    AppHeading,
    ListPageLayout,
    ...ASYNC_COMPONENTS,
  },
})
export default class AppCardsList extends Vue {
  @Prop({ type: String, default: 'Название' })
  readonly title!: string;

  @Prop({ type: String })
  readonly component!: Components;

  @Prop({ type: Array, default: () => [] })
  readonly list!: Array<Object>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppCardsList/AppCardsList.vue